import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.pruefcheckliste-entfernen';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPruefchecklisteEntfernenEffects {

    PruefchecklisteEntfernen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_PRUEFCHECKLISTE_ENTFERNEN),
        mergeMap((x: ac.PostPruefchecklisteEntfernenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postPruefchecklisteEntfernen(x.pruefchecklisteRequest).pipe(
                map((result: any) => {
                    return new ac.PostPruefchecklisteEntfernenErfolgreichAction(result, x.pruefchecklisteRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostPruefchecklisteEntfernenFehlerAction(error, x.pruefchecklisteRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
